import apiService from "./apiService";

const baseURL = process.env.REACT_APP_LOCATION_URL;

const getProvinces = (disabled=true) => {
  const queryParams = {
    disabled
  }
  return apiService.get(URIS.provinces, {params: queryParams})
}

const getCitiesByProvince = (provinceId, disabled=true) => {
  const queryParams = {
    parent_id: provinceId,
    disabled
  }
  return apiService.get(URIS.cities, {params: queryParams})
}

const getAreasByCity = (cityId, disabled=true) => {
  const queryParams = {
    parent_id: cityId,
    disabled
  }
  return apiService.get(URIS.areas, {params: queryParams})
}

const putProvince = (provinceId, name) => {
  return apiService.put(URIS_D('province', provinceId), {name: name})
}

const patchProvince = (provinceId, value, isCampaign) => {
  const payload = isCampaign ? {campaign_location: value} : {disabled: value};
  return apiService.patch(URIS_D('province', provinceId), payload)
}

const postCity = (provinceId, cities) => {
  return apiService.post(URIS_D('cities', provinceId), cities)
}

const
  putCity = (cityId, name) => {
    return apiService.put(URIS_D('city', cityId), {name: name})
  }

const patchCity = (cityId, value, isCampaign) => {
  const payload = isCampaign ? {campaign_location: value} : {disabled: value};
  return apiService.patch(URIS_D('city', cityId), payload)
}

const postArea = (cityId, areas) => {
  return apiService.post(URIS_D('areas', cityId), areas)
}

const putArea = (areaId, updatedArea) => {
  return apiService.put(URIS_D('area', areaId), updatedArea)
}

const patchArea = (areaId, value, isCampaign) => {
  const payload = isCampaign ? {campaign_location: value} : {disabled: value};
  return apiService.patch(URIS_D('area', areaId), payload)
}

const putLocation = (bulkPayload) => {
  return apiService.put(URIS.areas, bulkPayload)
}

export const postAddress = (address, customerId) => {
  return apiService.post(URIS_D("address", customerId), address);
}

export {
  getProvinces,
  getCitiesByProvince,
  getAreasByCity,
  putProvince,
  patchProvince,
  postCity,
  putCity,
  patchCity,
  postArea,
  putArea,
  patchArea,
  putLocation,
}

const URIS_D = (url, param1) => {
  return {
    province: `${baseURL}/api/province/${param1}`,
    city: `${baseURL}/api/city/${param1}`,
    area: `${baseURL}/api/area/${param1}`,
    cities: `${baseURL}/api/city/province/${param1}`,
    areas: `${baseURL}/api/area/city/${param1}`,
    address: `/pharmacy/customers/${param1}/addresses`
  }[url]
}

const URIS = {
  provinces: `${baseURL}/api/provinces`,
  cities: `${baseURL}/api/cities`,
  areas: `${baseURL}/api/areas`,
}
